import React from 'react';
import { useFullscreenContext } from '../../../utils/contexts/FullscreenContext';
import { SvgIcon } from '../../Icon';
import KubitTooltip from '../../KubitTooltip';
import { ChartHeaderIconWrapper } from './ChartHeaderUI';

const FullScreenToggle = () => {
  const { isFullScreen, toggleFullScreen } = useFullscreenContext();

  const handleClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    toggleFullScreen();
  };

  return (
    <KubitTooltip content={'Toggle full screen view'} placement="bottom-end">
      <ChartHeaderIconWrapper size={24} onClick={handleClick}>
        <SvgIcon
          name={isFullScreen ? 'corners-in' : 'corners-out'}
          width={16}
          height={16}
        />
      </ChartHeaderIconWrapper>
    </KubitTooltip>
  );
};

export default FullScreenToggle;
